import { z } from 'zod';
import { EventClassSchema } from './breakdown.js';
import { IsoDateSchema, TrackIdSchema, YearMonthSchema } from './common.js';
export const ConfidenceSchema = z.enum(['high', 'medium', 'low']);
export const AttributionSchema = z.object({
    knownEventId: z.number().int(),
    cause: z.string(),
    sourceUrl: z.string().nullable(),
    confidence: ConfidenceSchema.nullable(),
    eventDate: IsoDateSchema,
    eventType: z.string(),
    addedBy: z.string().nullable(),
});
export const TrackEventSchema = z.object({
    /** `${trackId}|${month}` */
    id: z.string(),
    trackId: TrackIdSchema,
    title: z.string(),
    month: YearMonthSchema,
    releaseDate: IsoDateSchema.nullable(),
    ageMonths: z.number().int().nullable(),
    class: EventClassSchema,
    /** Deviation from the trailing six-month median, as a fraction (0.5 = +50%). */
    dev: z.number(),
    value: z.number(),
    base: z.number(),
    gain: z.number(),
    /** Share of the lift still present six months on; null when not yet observable. */
    persist: z.number().nullable(),
    attribution: AttributionSchema.nullable(),
    /** ghost known_events in the same month not yet linked to this track-month. */
    candidates: z.array(z.object({
        knownEventId: z.number().int(),
        title: z.string(),
        eventDate: IsoDateSchema,
        eventType: z.string(),
    })),
});
export const EventsQuerySchema = z.object({
    class: z.enum(['all', 'campaign', 'revival']).default('all'),
    asOf: IsoDateSchema.optional(),
});
export const EventsResponseSchema = z.object({
    events: z.array(TrackEventSchema),
    thresholds: z.object({ dev: z.number(), minGain: z.number(), baselineMonths: z.number().int() }),
    excludedReleases: z.number().int(),
});
export const EVENT_THRESHOLDS = { dev: 0.5, minGain: 3_000_000, baselineMonths: 6 };
//# sourceMappingURL=events.js.map